export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13643.b30a93bd.jpg";